const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ===== ElronPrint: Hebrew UI translation for Shopify-provided labels =====
   Store primary locale is EN, so filter/sort labels arrive in English.
   This translates them client-side, incl. after facet AJAX updates. */
(function () {
  var EP_HE = {
    'Availability': 'זמינות',
    'Price': 'מחיר',
    'In stock': 'במלאי',
    'Out of stock': 'אזל מהמלאי',
    'Featured': 'מומלצים',
    'Best selling': 'הנמכרים ביותר',
    'Alphabetically, A-Z': 'לפי שם: א–ת',
    'Alphabetically, Z-A': 'לפי שם: ת–א',
    'Price, low to high': 'מחיר: מהנמוך לגבוה',
    'Price, high to low': 'מחיר: מהגבוה לנמוך',
    'Date, old to new': 'תאריך: מהישן לחדש',
    'Date, new to old': 'תאריך: מהחדש לישן',
    'Relevance': 'רלוונטיות',
    'Color': 'צבע',
    'Size': 'מידה',
    'Products': 'כל המוצרים',
    'Product type': 'סוג מוצר',
    'Brand': 'מותג',
    'More filters': 'מסננים נוספים'
  };

  function epTranslateNode(root) {
    if (!root) return;
    var sel = '.facets__summary-label, .mobile-facets__summary span, .facet-checkbox__text-label, #SortBy option, #SortBy-mobile option, .facets__summary span, .mobile-facets__close-button span, .active-facets__button-inner';
    var els;
    try { els = root.querySelectorAll(sel); } catch (e) { return; }
    els.forEach(function (el) {
      // options and simple labels: translate whole trimmed text
      var t = el.textContent.trim();
      if (EP_HE[t]) {
        el.textContent = EP_HE[t];
        return;
      }
      // pills like "Availability: In stock"
      if (t.indexOf(':') > -1) {
        var parts = t.split(':');
        var a = parts[0].trim(), b = parts.slice(1).join(':').trim();
        if (EP_HE[a] || EP_HE[b]) {
          var node = el.firstChild;
          if (node && node.nodeType === 3) {
            node.textContent = (EP_HE[a] || a) + ': ' + (EP_HE[b] || b) + ' ';
          }
        }
      }
    });
  }

  function epRun() {
    epTranslateNode(document);
    var grid = document.getElementById('ProductGridContainer');
    var targets = [grid, document.querySelector('.facets-container'), document.querySelector('.mobile-facets__wrapper')].filter(Boolean);
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () { epTranslateNode(document); });
      targets.forEach(function (t) { mo.observe(t, { childList: true, subtree: true }); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', epRun);
  } else {
    epRun();
  }
})();
